import * as React from 'react';
import { Box, BREAK_POINTS } from '@origin-digital/style-guide';
import styled from 'styled-components';

import { LayoutProps, BreakPoints } from './Layout.types';

const BREAK_POINTS_LOCAL: BreakPoints = BREAK_POINTS;

export const breakpoints = (min: string[], max: string[]): string => {
  let mediaQueries = ``;
  min.forEach((bp: string) => {
    mediaQueries += `@media only screen and (min-width: ${BREAK_POINTS_LOCAL.Min[bp]}) {
        width: ${BREAK_POINTS_LOCAL.Min[bp]}
      }`;
  });
  max.forEach((bp: string) => {
    mediaQueries += `@media only screen and (max-width: ${BREAK_POINTS_LOCAL.Max[bp]}) {
        width: ${BREAK_POINTS_LOCAL.Min[bp]}
      }`;
  });

  return mediaQueries;
};

export const Wrapper = styled.div`
  width: 100%;
  ${(props: { min: string[]; max: string[] }) => breakpoints(props.min, props.max)};
`;

const Layout: React.StatelessComponent<LayoutProps> = ({ children, ...props }: LayoutProps): JSX.Element => {
  return (
    <Box justifyContent="center" display="flex" paddingX={props.paddingX} paddingY={props.paddingY}>
      <Wrapper {...props}>{children}</Wrapper>
    </Box>
  );
};

export default Layout;
